import { WebUrlListTable } from '../components/WebUrlListTable';

export function WebUrlListPage() {
  return <WebUrlListTable />;
}
